import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';

import {
  EMSHocaFeatures,
  EmsHocaFeaturesProperties,
  Feature,
  FeatureNames,
  HemsConfigurationOverviewProperties,
  HemsType,
} from '@vi-iot/client';

import {
  HemsAdvancedAnalysisStatus,
  InstallationDetailsStore,
  InstallationFeaturesStore,
} from '@store';

import { UIService } from '../../../shared/services';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-hems',
  templateUrl: './hems.component.html',
  styleUrls: ['./hems.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsComponent implements OnInit {
  hemsSubscription$: Observable<HemsType>;
  readonly HemsAdvancedAnalysisStatus = HemsAdvancedAnalysisStatus;
  readonly hemsType = HemsType;

  @Input() boilerSerial: string;
  isSettingsVisible$: Observable<boolean>;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.isSettingsVisible$ = this.installationFeaturesStore
      .selectInstallationHemsFeature<EmsHocaFeaturesProperties, never>(FeatureNames.hocaFeatures)
      .pipe(
        map((feature) =>
          this.isAnyOfFinancialOptimizationFeaturesAvailable(feature?.properties?.supported?.value)
        )
      );
    this.hemsSubscription$ = this.installationFeaturesStore
      .selectInstallationGatewayFeature(FeatureNames.hemsConfigurationOverview)
      .pipe(
        map(
          (feature: Feature<HemsConfigurationOverviewProperties, never>) =>
            feature?.properties?.activeHemsType?.value
        )
      );
  }

  openSettingsOverlay(): void {
    this.uiService.openActiveOverlay(FeaturesDetailsOverlayTypeEnum.HemsSettings);
  }

  private isAnyOfFinancialOptimizationFeaturesAvailable(hocaFeatures: EMSHocaFeatures[]): boolean {
    const optimizationFeatures = [
      EMSHocaFeatures.PhotovoltaicExcessToHeatpump,
      EMSHocaFeatures.ForecastBasedBatteryOperation,
      EMSHocaFeatures.OnlineSolarIrradianceForecast,
      EMSHocaFeatures.TariffBasedFinancialOptimization,
    ];

    return optimizationFeatures.some((feature) => hocaFeatures?.includes(feature));
  }
}
